import { NavLink } from 'react-router-dom';
import logo from '../../../assets/img/logo.png'

const Footer = () => {
    return (
        <footer id="footer" className="footer-area shadow" >
            <div class="linea-color wow fadeIn" data-wow-duration="1.3s" data-wow-delay="0.2s"></div>
            <div className="footer-widget">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-lg-4 col-md-6">
                            <div className="footer-about text-center mt-50 wow fadeIn" data-wow-duration="1.3s" data-wow-delay="0.2s">
                                <a className="logo" href="/" >
                                    <img src={logo} alt="Logo" style={{ width: "100px" }} />
                                </a>
                                <p className="text">En Asilo A Tu Alcance te asesoramos con responsabilidad, honestidad y cumplimiento para que puedas resolver tu situación migratoria con confianza.</p>
                                <ul className="social">
                                    <li><a href="https://www.facebook.com/profile.php?id=61575030453380" target='_blank'><i className="bi bi-facebook"></i></a></li>
                                    <li><a href="https://www.instagram.com/asiloatualcance" target='_blank'><i className="bi bi-instagram"></i></a></li>
                                    <li><a href="https://www.tiktok.com/@asiloatualcance" target='_blank'><i className="bi bi-tiktok"></i></a></li>
                                    <li><a href="https://www.youtube.com/@PaolaMarcaAsesora" target='_blank'><i className="bi bi-youtube"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6">
                            <div className="footer-link d-flex flex-wrap">
                                <div className="footer-link-wrapper mt-45 wow fadeIn" data-wow-duration="1.3s" data-wow-delay="0.4s">
                                    <div className="footer-title">
                                        <h4 className="title fw-bold text-secondary">Links</h4>
                                    </div>
                                    <ul className="link">
                                        <li><a className="" href="/#home">Asilo</a></li>
                                        <li><a className="" href="/#quienes-somos">¿Quienes somos?</a></li>
                                        <li><a className="" href="/#nuestros-servicios">Nuestros servicios</a></li>
                                        <li><a className="" href="/#testimonios">Testimonios</a></li>
                                        <li>
                                            <NavLink to={`/login`} target="_blank" >Portal</NavLink>
                                        </li>

                                    </ul>
                                </div>

                                <div className="footer-link-wrapper mt-45 wow fadeIn" data-wow-duration="1.3s" data-wow-delay="0.6s">
                                    <div className="footer-title">
                                        <h4 className="title fw-bold text-secondary">Ayuda</h4>
                                    </div>
                                    <ul className="link">
                                        <li>
                                            <NavLink to={`/contacto`} className="">¿Necesitas ayuda con tu proceso migratorio?</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={`/financiacion`} className="">Financiación</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-contact mt-45 wow fadeIn" data-wow-duration="1.3s" data-wow-delay="0.8s">
                                <div className="footer-title">
                                    <h4 className="title fw-bold text-secondary">Contácto</h4>
                                </div>
                                <ul className="contact-list mt-4">
                                    <li>
                                        <div className="contact-info d-flex">
                                            <div className="info-content media-body">
                                                <p className="text"><i className="bi bi-phone"></i> +1 (689) 258-9039</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="contact-info d-flex">
                                            <div className="info-content media-body">
                                                <p className="text">
                                                    <a href="https://www.facebook.com/profile.php?id=61575030453380" target='_blank'><i className="bi bi-facebook"></i> Asilo a tu alcance</a>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="contact-info d-flex">
                                            <div className="info-content media-body">
                                                <p className="text">
                                                    <a href="https://www.instagram.com/asiloatualcance/" target='_blank'><i className="bi bi-instagram"></i> @asiloatualcance</a>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="contact-info d-flex">
                                            <div className="info-content media-body">
                                                <p className="text">
                                                    <a href='https://www.tiktok.com/@asiloatualcance' target='_blank'>
                                                        <i className="bi bi-tiktok"></i> @asiloatualcance
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="contact-info d-flex">
                                            <div className="info-content media-body">
                                                <p className="text">
                                                    <a href='https://www.youtube.com/@PaolaMarcaAsesora' target='_blank'>
                                                        <i className="bi bi-youtube"></i> @asiloatualcance
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright d-sm-flex justify-content-between p-0">
                                <div className="copyright-text text-center">
                                    <p className="text">Asilo a tu Alcance © {new Date().getFullYear()} | Todos los derechos reservados </p>
                                </div>

                                <div className="copyright-privacy text-center">
                                    <a href="https://kodevins.com" target='_blank'>@kodevins</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer >
    )
}

export default Footer;